import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';

import {
  flexCenter,
  flexDirectionColumn,
  spaceGapCozy,
  spaceGapCompact,
  SPACE_COZY,
  spaceGapMinimum,
  flex,
  alignItemsCenter,
  SPACE_MINIMUM,
  borderRadius,
} from '@/styles';

export const equationStyles = css`
  background-color: ${token('color.background.discovery')};
  padding: ${SPACE_COZY}px;
  ${borderRadius};
`;

export const equationTitleStyles = css`
  font-size: 12px;
  font-weight: 500;
`;

export const operatorStyles = css`
  font-size: 11px;
`;

export const editStyles = css`
  form {
    background-color: ${token('color.background.neutral.subtle.hovered')};
    border-radius: 3px;
    & > div {
      margin-top: 0;
    }
    input {
      max-width: 100px;
    }
  }
`;

export const faqStyles = css`
  background-color: ${token('color.background.warning')};
  padding: ${SPACE_COZY}px;
  ${borderRadius};
`;

export const equationRowStyles = css([flex, alignItemsCenter, spaceGapCozy]);
export const equationColumnStyles = css([flex, flexDirectionColumn, spaceGapMinimum]);
export const equationCellStyles = css([flexCenter, spaceGapCompact]);
export const equationCellWithEditStyles = css([
  flexCenter,
  spaceGapCompact,
  css`
    height: 24px;
    input {
      height: 20px !important;
    }
  `,
]);
export const equationLineStyles = css`
  border-top: 1px solid ${token('color.text')};
`;

export const calculationIconStyles = css`
  font-size: 10px;
  margin-right: 6px;
`;

export const iconStyles = css`
  ${flexCenter};
  margin-right: ${SPACE_MINIMUM}px;
  margin-left: -2px;
`;
